import React from 'react';

import {PlanGetSchema} from '../../../../api/DBSchema/Plan';
import BaseLocalUsers from "../../AbstractObjects/GatewayPlan/InnerPages/BaseLocalUsers";

const pageSchema = PlanGetSchema.pages.localUsers;
const pageId = pageSchema.pageId;

function PlanLocalUsers({
                                planObject,
                                setPlanData
                            }) {

    let pageData = planObject[pageId];

    return (
        <BaseLocalUsers
            pageData={pageData}
            setObjectData={setPlanData}
        />
    );
}

export default PlanLocalUsers;